module.exports = __webpack_public_path__ + "fontawesome-webfont.26efb89ed5261b9be06b.svg";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/font-awesome/fonts/fontawesome-webfont.svg?v=4.2.0
// module id = ../../../../../src/assets/font-awesome/fonts/fontawesome-webfont.svg?v=4.2.0
// module chunks = 2